import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { createHotel, updateHotel } from "services/HotelService";
import { getCities } from "services/CityService";

const HotelForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    contact_person_name: "",
    address: "",
    contact_number: "",
    email: "",
    state: "",
    category: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [cities, setCity] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const { isEdit, editFormData } = location.state || {
    isEdit: false,
    editFormData: {},
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    getCityList();
  }, []);

  useEffect(() => {
    if (isEdit && editFormData) {
      setFormData(editFormData);
    }
  }, [isEdit, editFormData]);

  const getCityList = () => {
    getCities().then((response) => {
      if (response && response.data.success) {
        setCity(response.data.cities);
      }
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const newErrors = validate();
      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
      } else {
        setErrors({});
        setLoading(true);

        let response;
        if (isEdit) {
          response = await updateHotel(formData);
        } else {
          response = await createHotel(formData);
        }

        setLoading(false);
        if (response?.data?.success) {
          navigate("/hotels");
        } else if (response?.data?.errors) {
          const serverErrors = {};
          for (const field in response.data.errors) {
            serverErrors[field] = response.data.errors[field][0];
          }
          setErrors(serverErrors);
        }
      }
    } catch (error) {
      console.error("Error adding hotel:", error);
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) {
      newErrors.name = "Name is required";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    }

    return newErrors;
  };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Add Hotel</h1>
          <small>Add New Hotel</small>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/hotels">
                    <i className="fa fa-list"></i> Hotels List{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label>Hotel Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Hotel Name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Hotel Address</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Address"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <label>Hotel Category</label>
                        <div className="search-form-input-1" id="first-select">
                          <select
                            id="category"
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                          >
                            <option value="disable">Hotel Category</option>
                            <option value="1">1 Star</option>
                            <option value="2">2 Star</option>
                            <option value="3">3 Star</option>
                            <option value="4">4 Star</option>
                            <option value="5">5 Star</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>City</label>
                      <select
                        className="form-control"
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option value={city.city_name}>
                            {city.city_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Contact Person Name</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Person Name"
                        name="contact_person_name"
                        value={formData.contact_person_name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Person Phone No.</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Phone No."
                        name="contact_number"
                        value={formData.contact_number}
                        onChange={handleChange}
                        required
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label>Email ID</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>

                  <div className="reset-button">
                    <button
                      type="submit"
                      className="btn btn-success"
                      disabled={loading}
                    >
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HotelForm;
